import axios from 'axios';

// Create an Axios instance
const axiosInstance = axios.create();

// Add an interceptor to set the JWT token in the headers
axiosInstance.interceptors.request.use(
  (config) => {
    // Assuming you have a function to get the JWT token from where it's stored (e.g., local storage or a variable)
    const token = sessionStorage.getItem("token");
    

    if (token) {
      // Add the JWT token to the Authorization header
      config.headers['Authorization'] = `Bearer ${token}`;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default axiosInstance;